import PropTypes from 'prop-types';
import './Radio.css';

export default function Radio({
    name,
    options = [],
    value,
    onChange,
    label,
    error,
    disabled = false,
    direction = 'vertical',
    className = ''
}) {
    return (
        <div className={`radio-group ${className}`}>
            {label && <label className="radio-group-label">{label}</label>}
            <div className={`radio-options radio-${direction}`}>
                {options.map((option) => (
                    <label
                        key={option.value}
                        className={`radio-wrapper ${disabled ? 'disabled' : ''}`}
                    >
                        <div className={`radio ${value === option.value ? 'checked' : ''} ${error ? 'error' : ''}`}>
                            <input
                                type="radio"
                                name={name}
                                value={option.value}
                                checked={value === option.value}
                                onChange={(e) => onChange?.(e.target.value)}
                                disabled={disabled}
                            />
                            <span className="radio-dot" />
                        </div>
                        <span className="radio-label">{option.label}</span>
                    </label>
                ))}
            </div>
            {error && <span className="radio-error">{error}</span>}
        </div>
    );
}

Radio.propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired
    })),
    value: PropTypes.string,
    onChange: PropTypes.func,
    label: PropTypes.string,
    error: PropTypes.string,
    disabled: PropTypes.bool,
    direction: PropTypes.oneOf(['vertical', 'horizontal']),
    className: PropTypes.string
};
